import { Tag } from 'nrosh-common/Api/CommonTypes';

export const compareTagNamesAlphabetically = (a: Tag, b: Tag): number => {
  if (a.name === b.name) return 0;
  return a.name > b.name ? 1 : -1;
};
